import { render, staticRenderFns } from "./LlLawArticle.vue?vue&type=template&id=f100c574"
import script from "./LlLawArticle.vue?vue&type=script&lang=js"
export * from "./LlLawArticle.vue?vue&type=script&lang=js"
import style0 from "./LlLawArticle.vue?vue&type=style&index=0&id=f100c574&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports